import api from '../services/api';

const PENDING_QUEUE_KEY = 'vision_click_offline_queue';

export const savePendingTransaction = (type, data) => {
    try {
        const queue = getPendingTransactions();
        const transaction = {
            id: Date.now().toString() + Math.random().toString(36).substr(2, 5),
            type,
            data,
            timestamp: new Date().toISOString()
        };
        queue.push(transaction);
        localStorage.setItem(PENDING_QUEUE_KEY, JSON.stringify(queue));
        return true;
    } catch (err) {
        console.error('Error saving to offline queue:', err);
        return false;
    }
};

export const getPendingTransactions = () => {
    try {
        const data = localStorage.getItem(PENDING_QUEUE_KEY);
        return data ? JSON.parse(data) : [];
    } catch (err) {
        return [];
    }
};

export const removePendingTransaction = (id) => {
    try {
        const queue = getPendingTransactions();
        const newQueue = queue.filter(item => item.id !== id);
        localStorage.setItem(PENDING_QUEUE_KEY, JSON.stringify(newQueue));
    } catch (err) {
        console.error('Error removing from queue:', err);
    }
};

export const syncAllPending = async () => {
    if (!navigator.onLine) return;
    
    const queue = getPendingTransactions();
    if (queue.length === 0) return;
    
    console.log(`Iniciando sincronización de ${queue.length} transacciones pendientes...`);
    
    if (window.isSyncing) return;
    window.isSyncing = true;
    
    try {
        for (const item of queue) {
            try {
                if (item.type === 'NEW_QUOTE_OR_CLINICAL_RECORD') {
                    const { patientData, patientId, recordData } = item.data;
                    let finalPatientId = patientId;
                    
                    if (!finalPatientId && patientData) {
                        try {
                            const resPatient = await api.post('/api/patients/', patientData);
                            finalPatientId = resPatient.data.id;
                        } catch (err) {
                            console.error('Error sincronizando paciente:', err);
                            if (err.response && err.response.status !== 500) {
                                console.error('Error de validación al crear paciente offline:', err.response.data);
                            } else {
                                throw err;
                            }
                        }
                    } else if (finalPatientId && patientData) {
                        await api.patch(`/api/patients/${finalPatientId}/`, patientData);
                    }
                    
                    if (finalPatientId) {
                        recordData.patient = finalPatientId;
                        if (item.data.existingQuoteId) {
                            await api.patch(`/api/clinical-records/${item.data.existingQuoteId}/`, recordData);
                        } else {
                            await api.post('/api/clinical-records/', recordData);
                        }
                    }
                }
                
                removePendingTransaction(item.id);
                console.log(`Transacción ${item.id} sincronizada con éxito.`);
            } catch (err) {
                console.error(`Fallo al sincronizar transacción ${item.id}:`, err);
                if (!err.response) break;
                if (err.response && err.response.status === 400) {
                    console.error('Eliminando transacción inválida de la cola:', err.response.data);
                    removePendingTransaction(item.id);
                }
            }
        }
    } finally {
        window.isSyncing = false;
        if (getPendingTransactions().length === 0) {
            console.log('Sincronización completada exitosamente.');
        }
    }
};
